// import React, { useEffect, useState } from "react";
// import { UserSwitchOutlined } from '@ant-design/icons';
// import { useAuthContext } from "../../components/AuthProvider";
// import { useBusinessContext } from "../../components/BusinessContext";
// import { useBusinessOwnerId } from "../../components/api/businessownerid";
// import { useNavigate } from 'react-router-dom';
// import tobImage from '../../assets/images/top-header.png';
// import { Select, message } from 'antd';

// function Topbar() {
//   const [businesses, setBusinesses] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const { handleLogoutUser, token, loginUser, fetchUser } = useAuthContext();
//   const { businessId, businessName, setBusiness, resetBusiness } = useBusinessContext();
//   const { businessOwnerId, loading: ownerIdLoading, error: ownerIdError } = useBusinessOwnerId();
//   const navigate = useNavigate();

//   // Determine greeting based on current time
//   const getGreeting = () => {
//     const hour = new Date().getHours();
//     if (hour < 12) return "Good Morning";
//     if (hour < 18) return "Good Afternoon";
//     return "Good Evening";
//   };

//   useEffect(() => {
//     if (loginUser) {
//       const initialValues = {
//         username: loginUser.username || '',
//         firstName: loginUser.firstName || '',
//         lastName: loginUser.lastName || '',
//         otherNames: loginUser.otherNames || '',
//         designation: loginUser.designation || '',
//         email: loginUser.email || '',
//         telephone: loginUser.telephone || '',
//         password: '',
//         confirmPassword: '',
//       };
     
//       console.log('Profile initialized with user:', loginUser);
//     }
//   }, [loginUser]);

//   // Fetch businesses when the component mounts and businessOwnerId is available
//   useEffect(() => {
//     const fetchBusinesses = async () => {
//       if (!businessOwnerId) {
//         console.log('No businessOwnerId, skipping fetch');
//         return;
//       }

//       setLoading(true);
//       try {
//         const response = await fetch(`https://api.synergytoss.net/api/v1/businesses/owner/${businessOwnerId}`, {
//           method: 'GET',
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//             "Cache-Control": "no-cache",
//             Pragma: "no-cache",
//             Expires: "0",
//           },
//         });
//         const data = await response.json();

//         if (Array.isArray(data)) {
//           setBusinesses(data);
//           console.log('Fetched businesses:', data);
//           // Validate current businessId
//           if (businessId && data.find(b => b.id === businessId)) {
//             console.log('Valid businessId found, retaining selection:', businessId);
//           } else if (data.length > 0 && !businessId) {
//             const firstBusiness = data[0];
//             console.log('Auto-selecting first business:', firstBusiness);
//             setBusiness(firstBusiness.id, firstBusiness.name, firstBusiness.logo);
//           } else if (data.length === 0) {
//             console.log('No businesses found for owner:', businessOwnerId);
//             message.warning('No Business');
//             if (businessId) {
//               console.log('Invalid businessId, resetting:', businessId);
//               resetBusiness();
//             }
//           }
//         } else {
//           console.warn('Unexpected API response:', data);
//           message.warning('No Business');
//           if (businessId) {
//             console.log('Invalid businessId, resetting:', businessId);
//             resetBusiness();
//           }
//         }
//       } catch (error) {
//         console.error('Error fetching businesses:', error);
//         message.error('Failed to fetch businesses');
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchBusinesses();
//   }, [token, businessId, setBusiness, resetBusiness, businessOwnerId]);

//   // Handle logout
//   const handleLogout = () => {
//     console.log('Initiating logout');
//     resetBusiness();
//     sessionStorage.removeItem("Role");
//     localStorage.clear();
//     handleLogoutUser();
//   };

//   // Handle profile navigation
//   const handleProfileNavigation = () => {
//     console.log('Navigating to profile page');
//     navigate('/admin/profile');
//   };

//   // Handle business selection
//   const handleBusinessSelect = (value) => {
//     const selectedBusiness = businesses.find(business => business.id === value);
//     if (selectedBusiness) {
//       console.log('Manually selecting business:', selectedBusiness);
//       setBusiness(selectedBusiness.id, selectedBusiness.name, selectedBusiness.logo);
//     }
//   };

//   // Find the selected business based on businessId
//   const selectedBusiness = businesses.find(business => business.id === businessId);
//   // Handle page refresh
//   const handleRefresh = () => {
//     console.log('Refreshing page');
//     window.location.reload();
//   };

//   return (
//     <>
//       <nav className="nav navbar navbar-expand-xl navbar-light iq-navbar">
//         <div className="container-fluid navbar-inner">
//           <a href="/dashboard/informational" className="navbar-brand">
//             <div className="logo-main">
//               <img src="/path/to/default-logo.png" alt="Default Logo" className="business-logo" />
//             </div>
//           </a>

//           <div className="business-select-container">
//             <Select
//               showSearch
//               placeholder="Select a business"
//               optionFilterProp="children"
//               onChange={handleBusinessSelect}
//               value={businessId}
//               loading={loading || ownerIdLoading}
//               style={{ width: 250 }}
//             >
//               {businesses.map(business => (
//                 <Select.Option key={business.id} value={business.id}>
//                   {business.name} ({business.businessType})
//                 </Select.Option>
//               ))}
//             </Select>
//           </div>

//           <li className="nav-item dropdown" onClick={handleRefresh}>
//             <a href="#" className="nav-link">
//               <svg
//                 width="20"
//                 height="20"
//                 viewBox="0 0 24 24"
//                 fill="none"
//                 xmlns="http://www.w3.org/2000/svg"
//               >
//                 <path
//                   d="M17.65 6.35C16.2 4.9 14.21 4 12 4C7.58 4 4.01 7.58 4.01 12C4.01 16.42 7.58 20 12 20C15.73 20 18.84 17.45 19.73 14H17.65C16.83 16.33 14.61 18 12 18C8.69 18 6 15.31 6 12C6 8.69 8.69 6 12 6C13.66 6 15.14 6.69 16.22 7.78L13 11H20V4L17.65 6.35Z"
//                   fill="currentColor"
//                 ></path>
//               </svg>
//               <span className="bg-danger dots"></span>
//             </a>
//             <div className="p-0 sub-drop dropdown-menu dropdown-menu-end" aria-labelledby="notification-drop"></div>
//           </li>

//           <button
//             className="navbar-toggler"
//             type="button"
//             data-bs-toggle="collapse"
//             data-bs-target="#navbarSupportedContent"
//             aria-controls="navbarSupportedContent"
//             aria-expanded="false"
//             aria-label="Toggle navigation"
//           >
//             <span className="navbar-toggler-icon">
//               <span className="mt-2 navbar-toggler-bar bar1"></span>
//               <span className="navbar-toggler-bar bar2"></span>
//               <span className="navbar-toggler-bar bar3"></span>
//             </span>
//           </button>

//           {/* Toggle page refresh */}
//           <div className="sidebar-toggle" data-toggle="refresh">
//             <i className="icon">
//               <svg
//                 width="20"
//                 height="20"
//                 viewBox="0 0 24 24"
//                 fill="none"
//                 xmlns="http://www.w3.org/2000/svg"
//               >
//                 <path
//                   d="M17.65 6.35C16.2 4.9 14.21 4 12 4C7.58 4 4.01 7.58 4.01 12C4.01 16.42 7.58 20 12 20C15.73 20 18.84 17.45 19.73 14H17.65C16.83 16.33 14.61 18 12 18C8.69 18 6 15.31 6 12C6 8.69 8.69 6 12 6C13.66 6 15.14 6.69 16.22 7.78L13 11H20V4L17.65 6.35Z"
//                   fill="currentColor"
//                 ></path>
//               </svg>
//             </i>
//           </div>

//           <div className="collapse navbar-collapse" id="navbarSupportedContent">
//             <ul className="mb-2 navbar-nav ms-auto align-items-center navbar-list mb-lg-0">
//               <li className="nav-item dropdown custom-drop">
//                 <a
//                   className="py-0 nav-link d-flex align-items-center"
//                   href="#"
//                   id="navbarDropdown"
//                   role="button"
//                   data-bs-toggle="dropdown"
//                   aria-expanded="false"
//                 >
//                   <UserSwitchOutlined style={{ fontSize: '25px', color: '#08c' }} />
//                 </a>
//                 <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="navbarDropdown">
//                   <li><a className="dropdown-item" onClick={handleProfileNavigation}>Profile</a></li>
//                   <li><a className="dropdown-item" href="../dashboard/app/user-profile.html">Privacy Setting</a></li>
//                   <li><hr className="dropdown-divider" /></li>
//                   <li><a className="dropdown-item" onClick={handleLogout}>Logout</a></li>
//                 </ul>
//               </li>
//             </ul>
//           </div>
//         </div>
//       </nav>

//       <div className="iq-navbar-header" style={{ height: "215px", backgroundImage: `url(${tobImage})` }}>
//         <div className="container-fluid iq-container">
//           <div className="row">
//             <div className="col-md-12">
//               <div className="flex-wrap d-flex justify-content-between align-items-center">
//                 <div>
//                   <h4 className="font-size-24">{getGreeting()}, {loginUser.firstName} {loginUser.lastName}</h4>
//                 </div>
//               </div>
//             </div>
//           </div>
//           <p>Your gateway to smarter operations, real-time insights, and seamless trading support.</p>
//         </div>
//       </div>
//     </>
//   );
// }

// export default Topbar;


import React, { useEffect, useState } from "react";
import { UserSwitchOutlined } from '@ant-design/icons';
import { useAuthContext } from "../../components/AuthProvider";
import { useBusinessContext } from "../../components/BusinessContext";
import { useBusinessOwnerId } from "../../components/api/businessownerid";
import { useNavigate } from 'react-router-dom';
import tobImage from '../../assets/images/top-header.png';
import { Select, message } from 'antd';

function Topbar() {
  const [businesses, setBusinesses] = useState([]);
  const [loading, setLoading] = useState(false);
  const { handleLogoutUser, token, loginUser, fetchUser } = useAuthContext();
  const { businessId, businessName, setBusiness, resetBusiness } = useBusinessContext();
  const { businessOwnerId, loading: ownerIdLoading, error: ownerIdError } = useBusinessOwnerId();
  const navigate = useNavigate();

  // Determine greeting based on current time
  const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour < 12) return "Good Morning";
    if (hour < 18) return "Good Afternoon";
    return "Good Evening";
  };

  useEffect(() => {
    if (loginUser) {
      const initialValues = {
        username: loginUser.username || '',
        firstName: loginUser.firstName || '',
        lastName: loginUser.lastName || '',
        otherNames: loginUser.otherNames || '',
        designation: loginUser.designation || '',
        email: loginUser.email || '',
        telephone: loginUser.telephone || '',
        password: '',
        confirmPassword: '',
      };
     
      console.log('Profile initialized with user:', loginUser);
    }
  }, [loginUser]);

  // Function to fetch BC configuration for the selected business
  const fetchBcConfiguration = async (businessId) => {
    if (!businessId) return;
    
    try {
      const response = await fetch(`https://api.synergytoss.net/api/v1/erpconfigurations/business/${businessId}`, {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
        },
      });
      
      const data = await response.json();
      
      // Check if response is not empty
      if (data && Array.isArray(data) && data.length > 0) {
        console.log('BC Configuration found:', data);
        sessionStorage.setItem('hasBcConfig', 'true');
      } else {
        console.log('No BC Configuration found');
        sessionStorage.setItem('hasBcConfig', 'false');
      }
    } catch (error) {
      console.error('Error fetching BC configuration:', error);
      sessionStorage.setItem('hasBcConfig', 'false');
    }
  };

  // Fetch businesses when the component mounts and businessOwnerId is available
  useEffect(() => {
    const fetchBusinesses = async () => {
      if (!businessOwnerId) {
        console.log('No businessOwnerId, skipping fetch');
        return;
      }

      setLoading(true);
      try {
        const response = await fetch(`https://api.synergytoss.net/api/v1/businesses/owner/${businessOwnerId}`, {
          method: 'GET',
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
            Expires: "0",
          },
        });
        const data = await response.json();

        if (Array.isArray(data)) {
          setBusinesses(data);
          console.log('Fetched businesses:', data);
          // Validate current businessId
          if (businessId && data.find(b => b.id === businessId)) {
            console.log('Valid businessId found, retaining selection:', businessId);
            // Fetch BC config for existing business
            fetchBcConfiguration(businessId);
          } else if (data.length > 0 && !businessId) {
            const firstBusiness = data[0];
            console.log('Auto-selecting first business:', firstBusiness);
            setBusiness(firstBusiness.id, firstBusiness.name, firstBusiness.logo);
            // Fetch BC config for auto-selected business
            fetchBcConfiguration(firstBusiness.id);
          } else if (data.length === 0) {
            console.log('No businesses found for owner:', businessOwnerId);
            message.warning('No Business');
            if (businessId) {
              console.log('Invalid businessId, resetting:', businessId);
              resetBusiness();
            }
            sessionStorage.setItem('hasBcConfig', 'false');
          }
        } else {
          console.warn('Unexpected API response:', data);
          message.warning('No Business');
          if (businessId) {
            console.log('Invalid businessId, resetting:', businessId);
            resetBusiness();
          }
          sessionStorage.setItem('hasBcConfig', 'false');
        }
      } catch (error) {
        console.error('Error fetching businesses:', error);
        message.error('Failed to fetch businesses');
        sessionStorage.setItem('hasBcConfig', 'false');
      } finally {
        setLoading(false);
      }
    };

    fetchBusinesses();
  }, [token, businessId, setBusiness, resetBusiness, businessOwnerId]);

  // Handle logout
  const handleLogout = () => {
    console.log('Initiating logout');
    resetBusiness();
    sessionStorage.removeItem("Role");
    sessionStorage.removeItem("hasBcConfig");
    localStorage.clear();
    handleLogoutUser();
  };

  // Handle profile navigation
  const handleProfileNavigation = () => {
    console.log('Navigating to profile page');
    navigate('/admin/profile');
  };

  // Handle business selection
// In your Topbar component, update the handleBusinessSelect function:
const handleBusinessSelect = (value) => {
  const selectedBusiness = businesses.find(business => business.id === value);
  if (selectedBusiness) {
    console.log('Manually selecting business:', selectedBusiness);
    setBusiness(selectedBusiness.id, selectedBusiness.name, selectedBusiness.logo);
    // Fetch BC config when business is manually selected
    fetchBcConfiguration(selectedBusiness.id);
    
    // Dispatch custom event for menu to update
    window.dispatchEvent(new CustomEvent('businessChanged', { 
      detail: { businessId: selectedBusiness.id, businessName: selectedBusiness.name }
    }));
    
    // Also dispatch bcConfigChanged event if needed
    const hasBcConfig = sessionStorage.getItem('hasBcConfig') === 'true';
    window.dispatchEvent(new CustomEvent('bcConfigChanged', { 
      detail: { hasBcConfig }
    }));
  }
};

  // Find the selected business based on businessId
  const selectedBusiness = businesses.find(business => business.id === businessId);
  
  // Handle page refresh
  const handleRefresh = () => {
    console.log('Refreshing page');
    window.location.reload();
  };

  return (
    <>
      <nav className="nav navbar navbar-expand-xl navbar-light iq-navbar">
        <div className="container-fluid navbar-inner">
          <a href="/dashboard/informational" className="navbar-brand">
            <div className="logo-main">
              <img src="/path/to/default-logo.png" alt="Default Logo" className="business-logo" />
            </div>
          </a>

          <div className="business-select-container">
            <Select
              showSearch
              placeholder="Select a business"
              optionFilterProp="children"
              onChange={handleBusinessSelect}
              value={businessId}
              loading={loading || ownerIdLoading}
              style={{ width: 250 }}
            >
              {businesses.map(business => (
                <Select.Option key={business.id} value={business.id}>
                  {business.name} ({business.businessType})
                </Select.Option>
              ))}
            </Select>
          </div>

          <li className="nav-item dropdown" onClick={handleRefresh}>
            <a href="#" className="nav-link">
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.65 6.35C16.2 4.9 14.21 4 12 4C7.58 4 4.01 7.58 4.01 12C4.01 16.42 7.58 20 12 20C15.73 20 18.84 17.45 19.73 14H17.65C16.83 16.33 14.61 18 12 18C8.69 18 6 15.31 6 12C6 8.69 8.69 6 12 6C13.66 6 15.14 6.69 16.22 7.78L13 11H20V4L17.65 6.35Z"
                  fill="currentColor"
                ></path>
              </svg>
              <span className="bg-danger dots"></span>
            </a>
            <div className="p-0 sub-drop dropdown-menu dropdown-menu-end" aria-labelledby="notification-drop"></div>
          </li>

          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon">
              <span className="mt-2 navbar-toggler-bar bar1"></span>
              <span className="navbar-toggler-bar bar2"></span>
              <span className="navbar-toggler-bar bar3"></span>
            </span>
          </button>

          <div className="sidebar-toggle" data-toggle="refresh">
            <i className="icon">
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.65 6.35C16.2 4.9 14.21 4 12 4C7.58 4 4.01 7.58 4.01 12C4.01 16.42 7.58 20 12 20C15.73 20 18.84 17.45 19.73 14H17.65C16.83 16.33 14.61 18 12 18C8.69 18 6 15.31 6 12C6 8.69 8.69 6 12 6C13.66 6 15.14 6.69 16.22 7.78L13 11H20V4L17.65 6.35Z"
                  fill="currentColor"
                ></path>
              </svg>
            </i>
          </div>

          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="mb-2 navbar-nav ms-auto align-items-center navbar-list mb-lg-0">
              <li className="nav-item dropdown custom-drop">
                <a
                  className="py-0 nav-link d-flex align-items-center"
                  href="#"
                  id="navbarDropdown"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <UserSwitchOutlined style={{ fontSize: '25px', color: '#08c' }} />
                </a>
                <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="navbarDropdown">
                  <li><a className="dropdown-item" onClick={handleProfileNavigation}>Profile</a></li>
                  <li><a className="dropdown-item" href="../dashboard/app/user-profile.html">Privacy Setting</a></li>
                  <li><hr className="dropdown-divider" /></li>
                  <li><a className="dropdown-item" onClick={handleLogout}>Logout</a></li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      <div className="iq-navbar-header" style={{ height: "215px", backgroundImage: `url(${tobImage})` }}>
        <div className="container-fluid iq-container">
          <div className="row">
            <div className="col-md-12">
              <div className="flex-wrap d-flex justify-content-between align-items-center">
                <div>
                  <h4 className="font-size-24">{getGreeting()}, {loginUser.firstName} {loginUser.lastName}</h4>
                </div>
              </div>
            </div>
          </div>
          <p>Your gateway to smarter operations, real-time insights, and seamless trading support.</p>
        </div>
      </div>
    </>
  );
}

export default Topbar;